import classNames from "classnames";
import {
	KeyboardEvent,
	PropsWithChildren,
	ReactElement,
	Ref
} from "react";
import { ControlAttachmentOptions, getAttachmentClassNames } from "../ControlAttachment";
import styles from "./DropOverPreview.module.less";
import { ButtonBase } from "../ButtonBase/ButtonBase";
import { IconButtonLike } from "../IconButton/IconButtonLike";

export type DropOverPreviewProps = {
	isOpen: boolean;
	isInvalid?: boolean;
	isDisabled?: boolean;
	isPlaceholder?: boolean;
	attachedOn?: ControlAttachmentOptions;
	onClick(): void;
	height?: "default" | "large";
	tooltip?: string;
	id: string | undefined;
	onKeyDown?: (args: KeyboardEvent<HTMLButtonElement>) => void;
	ref?: Ref<HTMLButtonElement>;
	ariaHaspopup?: "listbox" | "dialog" | true;
	ariaControls?: string;
	ariaLabel?: string;
};

export const DropOverPreview = (props: PropsWithChildren<DropOverPreviewProps>): ReactElement => {
	const {
		isOpen,
		isInvalid = false,
		isDisabled = false,
		isPlaceholder = false,
		attachedOn = [],
		height = "default",
		onClick,
		tooltip,
		id,
		onKeyDown,
		children,
		ref,
		ariaHaspopup = true,
		ariaControls,
		ariaLabel
	} = props;

	return (
		<ButtonBase
			className={classNames(
				styles.root,
				{
					[styles.root_isOpen]: isOpen,
					[styles.root_isInvalid]: isInvalid,
					[styles.root_isDisabled]: isDisabled,
					[styles.root_isPlaceholder]: isPlaceholder,
					[styles.root_largeHeight]: height === "large"
				},
				getAttachmentClassNames(attachedOn)
			)}
			onClick={onClick}
			disabled={isDisabled}
			title={tooltip}
			id={id}
			onKeyDown={onKeyDown}
			ref={ref}
			aria-haspopup={ariaHaspopup}
			aria-expanded={isOpen}
			aria-controls={ariaControls}
			aria-label={ariaLabel}
		>
			<div className={styles.preview}>
				{ children }
			</div>
			<div className={styles.suffix} aria-hidden>
				<IconButtonLike
					trackingId="dropover-preview-chevron-down"
					icon="chevron-down"
					kind="transparent"
					hasNoBorderRadius
					isDisabled={isDisabled}
					height="fill"
					width="fill"
				/>
			</div>
		</ButtonBase>
	);
};
DropOverPreview.displayName = "DropOverPreview";
